import { render, staticRenderFns } from "./SettimanaTipo.vue?vue&type=template&id=7a09060c"
import script from "./SettimanaTipo.vue?vue&type=script&lang=js"
export * from "./SettimanaTipo.vue?vue&type=script&lang=js"
import style0 from "./SettimanaTipo.vue?vue&type=style&index=0&id=7a09060c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports